// extracted by mini-css-extract-plugin
export default {"table":"table_table__JvnL6","thead":"table_thead__Blory","th":"table_th__xAfbX","th-content":"table_th-content__OiAxU","td":"table_td__xqIxB","tr":"table_tr__KSfEo"};